import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AddressPartialState } from './address.reducer';
import { AddressQuery } from './address.selectors';
import * as AddressActions from './address.actions';
import { ActionWithCorrelationAttributes } from '@kion/ngrx-helper';
import {Address} from "@kion/data-models";

@Injectable()
export class AddressFacade {

  all$ = this.store.pipe(select(AddressQuery.getAllAddress));
  allById$ = this.store.pipe(select(AddressQuery.getAllAddressById));
  searchResults$ = this.store.pipe(select(AddressQuery.getSearchResults));
  isSearching$ = this.store.pipe(select(AddressQuery.getIsSearching));
  lastCreatedId$ = this.store.pipe(select(AddressQuery.getLastCreatedId));
  lastCreatedAddress$ = this.store.pipe(select(AddressQuery.getLastCreatedAddress));

  constructor(private store: Store<AddressPartialState>) { }

  protected dispatch(action, correlationId?: string): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }

  createAddress(address: Partial<Address>, basketId: string, isInvoice: boolean, userId?: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      AddressActions.createAddress({ address: address, basketId: basketId,  isInvoice: isInvoice, userId: userId }),
      correlationId
    );
  }

  updateAddress(addressId: string, address: Partial<Address>, userId?: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(
      AddressActions.updateAddress({addressId: addressId, address: address, userId: userId }),
      correlationId
    );
  }

  loadAll(correlationId?: string): ActionWithCorrelationAttributes {
	this.clearAll();    
	return this.dispatch(
      AddressActions.loadAll(),
      correlationId
    )
  }
  clearAll(correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(AddressActions.clearAddresses(), correlationId);
  }
}
